<template>
    <div class="card rounded-[5px] w-full h-full">
        <p class="text-[21px] font-semibold m-0 p-0">Targeting</p>

        <div class="flex flex-col md:flex-row gap-4 mx-[8%] pb-12 h-full">
            <!-- <addlocation-map class="w-full" /> -->
            <!-- <create-circle-map class="w-full" /> -->

            <div class="flex flex-col w-full h-full justify-center">
                <!-- <div class="flex justify-between px-[4px]">
                    <p class="text-[18px] text-primary font-semibold flex items-center">
                        Location : {{ markers.length }}
                    </p>
                    <div></div>

                    <button
                        class="px-4 py-2 m-2 bg-red-700 text-white rounded-[5px]"
                        @click="handleRemove()"
                    >
                        Delete all
                    </button>
                </div>
                <div
                    id="mapDiv"
                    class="w-full h-80"
                    :class="[validateMarker ? 'border-2 border-red-400' : '']"
                ></div> -->
                <!--  :class="[validateMarker ? 'border-2 border-red-400' : '']"-->
                <map-marker-input class="w-full h-80" @input="handleInput" />
            </div>

            <div
                class="flex flex-col justify-center content-center mx-4 w-auto col-start-4 col-end-7"
            >
                <div v-if="validateMarker" class="text-red-600 flex justify-start font-semibold">
                    Please Add a Location!
                </div>
                <p class="text-[18px] font-semibold mb-2">Adding a Location</p>
                <ul class="list-decimal mx-4 mb-12 text-[14px] text-black">
                    <li>Click "Add"</li>
                    <li>Click and drag the marker to change the target location.</li>
                    <li>Click and drag the edges of the marker to resize the target area.</li>
                </ul>
                <!-- <p class="text-[18px] font-semibold mb-2">Removing a location</p>
                 <ul class="list-decimal mx-4 text-[14px] text-black">
                    <li>Right click on a marker</li>
                    <li>Click "OK" to confirm</li>
                </ul> -->
            </div>
        </div>
    </div>
    <div class="flex gap-2 flex-row-reverse mt-4">
        <button
            class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
            @click="next()"
            v-if="$store.state.step < 4"
        >
            Next
        </button>
        <button
            class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
            v-if="$store.state.step == 4"
        >
            Submit
        </button>
        <button
            class="bg-white p-2 px-[66px] rounded-[5px] text-primary border-2 border-primary"
            @click="back()"
            v-if="$store.state.step > 1"
        >
            Back
        </button>
    </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";

import MapMarkerInput from "../Map/MapMarkerInput.vue";
import { mapGetters } from "vuex";
export default {
    components: { MapMarkerInput },
    data() {
        return {
            map: null,
            markers: [],
            validateMarker: false,
        };
    },
    async mounted() {
        this.markers = this.step_two;
    },
    computed: {
        ...mapGetters(["step_two"]),
    },
    methods: {
        handleInput(event) {
            let markers = event.map((marker) => {
                return {
                    center: {
                        lat: marker.center.lat(),
                        lng: marker.center.lng(),
                    },
                    radius: marker.radius,
                };
            });
            this.markers = markers;
            this.validateMarker = false;
        },

        next() {
            if (this.markers.length < 1) {
                this.validateMarker = true;
                window.scrollTo(0, 0);
            } else {
                this.$store.commit("updataStepTwo", this.markers);
                if (this.$store.state.step < 4) {
                    this.$store.state.step = this.$store.state.step + 1;
                    window.scrollTo(0, 0);
                }
            }
        },
        back() {
            if (this.$store.state.step > 1) {
                this.$store.state.step = this.$store.state.step - 1;
            }
            window.scrollTo(0, 0);
        },
    },
};
</script>

<style>
label {
    display: inline-block;
    background-color: white;
    color: black;
    padding: 0.5rem;
    font-family: sans-serif;
    border-radius: 0.3rem;
    cursor: pointer;
    margin-top: 22px;
    margin-bottom: 22px;
}
</style>
